import { Card, CardContent } from '../../../components/ui/card';

interface SummaryCardProps {
  icon: React.ComponentType<{ className?: string }>;
  label: string;
  value: string | number;
  hint: string;
  color: string;
}

export function SummaryCard({ icon: Icon, label, value, hint, color }: SummaryCardProps) {
  return (
    <Card>
      <CardContent className="pt-4 pb-3 px-4">
        <div className="flex items-start justify-between gap-2">
          <div>
            <p className="text-xs font-medium text-muted-foreground">{label}</p>
            <p className={`text-2xl font-bold mt-1 ${color}`}>{value}</p>
            <p className="text-xs text-muted-foreground mt-1 leading-snug">{hint}</p>
          </div>
          <Icon className={`h-5 w-5 ${color} opacity-60 shrink-0`} />
        </div>
      </CardContent>
    </Card>
  );
}
